import * as Sentry from "@sentry/browser";
import { beforeSend } from "./integrations/index.js";

const integrations = []

if(SentryVars.modules.trace) {
  integrations.push(Sentry.browserTracingIntegration())
}

if(SentryVars.modules.replay) {
  integrations.push(Sentry.replayIntegration())
}

Sentry.init({
    dsn: SentryVars.dsn,
    environment: SentryVars.environment,
  
    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    release: SentryVars.release,
    integrations,
  
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend,
  });